import CircularProgress from '@mui/material/CircularProgress';
import Box from "@mui/material/Box";




export default function Loading() {
  return (<Box display="flex" justifyContent="center" sx={{width: '100%' , height:'100%' ,padding:'20%' }} >
  <CircularProgress />
</Box>)
}
